'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setFilters = setFilters;
exports.setPriceRange = setPriceRange;
exports.clearPriceRange = clearPriceRange;
exports.clear = clear;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// filters state contains a filters array and a priceRange object,
// filters state is used for displaying filters

var SET_FILTERS = 'filters/SET_FILTERS';
var SET_PRICE_RANGE = 'filters/SET_PRICE_RANGE';
var CLEAR_PRICE_RANGE = 'filters/CLEAR_PRICE_RANGE';
var CLEAR = 'filters/CLEAR';

var initialState = {
  filters: [{
    id: 'rate-5',
    name: '5 Stars',
    count: 0,
    checked: false
  }, {
    id: 'rate-4',
    name: '4 Stars',
    count: 0,
    checked: false
  }, {
    id: 'rate-3',
    name: '3 Stars',
    count: 0,
    checked: false
  }, {
    id: 'rate-2',
    name: '2 Stars',
    count: 0,
    checked: false
  }, {
    id: 'rate-1',
    name: '1 Star',
    count: 0,
    checked: false
  }, {
    id: 'hotel-internet',
    name: 'Internet',
    count: 0,
    checked: false
  }, {
    id: 'hotel-creditcard',
    name: 'Credit cards accepted',
    count: 0,
    checked: false
  }, {
    id: 'hotel-shuttle',
    name: 'Shuttle service available',
    count: 0,
    checked: false
  }, {
    id: 'hotel-wheelchair',
    name: 'Wheelchair-accessible',
    count: 0,
    checked: false
  }, {
    id: 'room-internet',
    name: 'Internet',
    count: 0,
    checked: false
  }, {
    id: 'room-nonsmoking',
    name: 'Non-smoking',
    count: 0,
    checked: false
  }, {
    id: 'room-smoking',
    name: 'Smoking',
    count: 0,
    checked: false
  }, {
    id: 'room-washlet',
    name: 'Toilet with washlet',
    count: 0,
    checked: false
  }, {
    id: 'meal-breakfast',
    name: 'Breakfast includes',
    count: 0,
    checked: false
  }, {
    id: 'meal-dinner',
    name: 'Dinner includes',
    count: 0,
    checked: false
  }],
  priceRange: {
    // the whole price boundary
    min: 1,
    max: 10000,
    // the user selected price boundary
    low: null,
    high: null
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_FILTERS:
      return (0, _extends3.default)({}, state, {
        filters: action.filters
      });
    case SET_PRICE_RANGE:
      // TODO: deal with exceptions like max < min or type errors
      return (0, _extends3.default)({}, state, {
        priceRange: (0, _extends3.default)({}, state.priceRange, action.priceRange)
      });
    case CLEAR_PRICE_RANGE:
      return (0, _extends3.default)({}, state, {
        priceRange: (0, _extends3.default)({}, initialState.priceRange)
      });
    case CLEAR:
      return (0, _extends3.default)({}, initialState);
    default:
      return state;
  }
}

function setFilters(filters) {
  return {
    type: SET_FILTERS,
    filters: filters
  };
}

function setPriceRange() {
  var priceRange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var range = {};
  if (priceRange.max) {
    range.max = Number(priceRange.max);
  }
  if (priceRange.min) {
    range.min = Number(priceRange.min) === 0 ? 1 : Number(priceRange.min);
  }
  if (priceRange.high) {
    range.high = Number(priceRange.high);
  }
  if (priceRange.low) {
    range.low = Number(priceRange.low) === 0 ? 1 : Number(priceRange.low);
  }

  return {
    type: SET_PRICE_RANGE,
    priceRange: range
  };
}

function clearPriceRange() {
  return {
    type: CLEAR_PRICE_RANGE
  };
}

function clear() {
  return {
    type: CLEAR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/filters.js
// module id = 146
// module chunks = 0